import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { Tooltip, Area, AreaChart, Line, ResponsiveContainer, XAxis, YAxis } from 'recharts'
import nodata from "../../../Utils/assets/img/leads_no_data_found_removebg.png"
import { IconFilter, IconPointFilled } from '@tabler/icons-react'
import { GetRequest } from '../../../Utils/hooks/ApiHandler'
import useLocalStorageState from 'use-local-storage-state'
import { useNavigate } from 'react-router-dom'

export const RevenueAnalytics = () => {
    const [customer, setCustomer] = useLocalStorageState("customer")
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication
    const navigate = useNavigate()

    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }

    const [filter, setFilter] = useState("Yearly")
    // revenue analytics statee1
    const [revenueDuration, setRevenueDuration] = useState("year")
    const [analyticsData, setAnalyticsData] = useState([])
    // revenue analytics api fetch
    useEffect(() => {
        ; (async () => {
            try {
                let res
                if (revenueDuration === "year") {
                    res = await GetRequest(
                        `dashboard/revenueAnalytics_${revenueDuration}/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
                        { headers },
                        extras
                    )
                } else if (revenueDuration === "month") {
                    res = await GetRequest(
                        `dashboard/revenueAnalytics_${revenueDuration}/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
                        { headers },
                        extras
                    )
                } else {
                    res = await GetRequest(
                        `dashboard/revenueAnalytics_${revenueDuration}/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
                        { headers },
                        extras
                    )
                }
                if (res.status === false) {
                    return
                }
                const revData =
                    res.data &&
                    res.data?.map((c) => ({ ...c, month: c.month?.slice(0, 3) }))
                setAnalyticsData(revData)
            } catch (error) {
                return
            }
        })()
    }, [revenueDuration])

  
    return (
        <div className="col-xl-12 ">
            <div className="card px-2 pb-2" >
                <div className=" border-0 d-flex pe-0 pt-0 mt-0 justify-content-between">
                    <span className="addEnquiryHead " style={{ fontWeight: 600, paddingLeft: '2rem' }}>Revenue Analytics</span>
                    <Dropdown align={"end"} style={{ marginTop: "-0.2rem" }}>
                        <Dropdown.Toggle
                            as="button"
                            // onClick={() => setOpenFilter(prev => !prev)}
                            className="btn btn-light d-flex align-items-center gap-2 px-2 py-1 text-muted no-arrow"
                            style={{ fontSize: '13px', borderRadius: '8px', fontWeight: '600', border: '1px solid #efefef', textTransform: 'capitalize' }}
                        >
                            <IconFilter size={16} color="#7a3a5e" />
                            {revenueDuration}
                            <i className="fa-solid fa-chevron-down align-middle ms-1 d-inline-block"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu >
                            <Dropdown.Item
                                onClick={() => setRevenueDuration("year")}
                            >
                                Year
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => setRevenueDuration("week")}
                            >
                                Week
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => setRevenueDuration("month")}
                            >
                                Month
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <hr className='mb-0 mt-2' />
                <div className="p-4 pb-0 " style={{}}>
                    {
                        analyticsData?.length !== 0 ?
                            <div className="crm-content-wrapper d-flex flex-column gap-3">
                                <div
                                    className="fs-12 text-secondary"
                                    style={{ fontWeight: 500 }}
                                >
                                    Revenue analytics with Sales and Profit (USD)
                                </div>
                                <div style={{ minHeight: 365 }}>
                                    <ResponsiveContainer width="100%" height={350}>
                                        <AreaChart
                                            data={analyticsData}
                                            margin={{
                                                top: 10,
                                                right: 10,
                                                left: 10,
                                                bottom: 10,
                                            }}
                                        >
                                            <defs>
                                                <linearGradient
                                                    id="salesGradient"
                                                    x1="0"
                                                    y1="0"
                                                    x2="0"
                                                    y2="1"
                                                >
                                                    <stop
                                                        offset="0%"
                                                        stopColor="rgba(119, 119, 142, 0.2)"
                                                        stopOpacity={0.8}
                                                    />
                                                    <stop
                                                        offset="100%"
                                                        stopColor="rgba(119, 119, 142, 0.05)"
                                                        stopOpacity={0}
                                                    />
                                                </linearGradient>
                                                <linearGradient
                                                    id="projectionGradient"
                                                    x1="0"
                                                    y1="0"
                                                    x2="0"
                                                    y2="1"
                                                >
                                                    <stop
                                                        offset="0%"
                                                        stopColor="rgba(255, 193, 7, 0.2)"
                                                        stopOpacity={0.8}
                                                    />
                                                    <stop
                                                        offset="100%"
                                                        stopColor="rgba(255, 193, 7, 0.05)"
                                                        stopOpacity={0}
                                                    />
                                                </linearGradient>
                                            </defs>
                                            <XAxis
                                                dataKey="month"
                                                tick={{ fontSize: 12 }}
                                                axisLine={false}
                                            />
                                            <YAxis
                                                tickFormatter={(v) =>
                                                    `₹${(v / 1000).toFixed(0)}`
                                                }
                                                tick={{ fontSize: 12 }}
                                                interval={0}
                                                axisLine={true}
                                            />

                                            <Tooltip content={<CustomTooltip />} />
                                            <Area
                                                type="monotone"
                                                dataKey="sales"
                                                stroke="#a7a1a1"
                                                fill="url(#salesGradient)"
                                                fillOpacity={1}
                                                baseValue={0}
                                            />
                                            <Line
                                                type="monotone"
                                                dataKey="Projection"
                                                stroke="#845adf"
                                                strokeWidth={2}
                                                dot={false}
                                            />
                                            <Line
                                                type="monotone"
                                                dataKey="revenue"
                                                stroke="rgba(35, 183, 229, 0.85)"
                                                strokeWidth={2}
                                                strokeDasharray="5 5"
                                                dot={false}
                                            />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                            :
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ position: "absolute", left: "10%", top: "3rem" }}
                            >
                                <img
                                    src={nodata}
                                    alt="nodata_found_img"
                                    style={{ width: "17rem", marginTop: "0" }}
                                />
                            </div>
                    }
                </div>
                <div className="d-flex justify-content-center pb-3 gap-1">
                    <span style={{ fontSize: "12px" }}>
                        <IconPointFilled
                            size={28}
                            stroke={0}
                            fill="#845adf"
                        ></IconPointFilled>
                        Projection
                    </span>
                    <span style={{ fontSize: "12px" }}>
                        {" "}
                        <IconPointFilled
                            size={28}
                            stroke={0}
                            fill="rgba(35, 183, 229, 0.85)"
                        ></IconPointFilled>
                        Revenue
                    </span>
                    <span style={{ fontSize: "12px" }}>
                        {" "}
                        <IconPointFilled
                            size={28}
                            stroke={0}
                            fill="#dfdfeb"
                        ></IconPointFilled>
                        Sales
                    </span>
                </div>
            </div>
        </div>
    )
}


const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        // Format large numbers with commas
        const formatNumber = (num) => {
            if (!num) return "0"
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }

        return (
            <div
                className="crm-card crm-custom-card"
                style={{
                    backgroundColor: "white",
                    padding: "12px 16px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "6px",
                    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                    fontSize: "12px",
                    minWidth: "160px",
                }}
            >
                <p
                    style={{
                        margin: "0 0 8px 0",
                        fontWeight: "600",
                        color: "#2d3748",
                        borderBottom: "1px solid #e2e8f0",
                        paddingBottom: "4px",
                    }}
                >
                    {label}
                </p>

                {/* Show Projection and revenue from payload */}
                {payload?.map((entry, index) => {
                    return (
                        <p
                            key={index}
                            style={{
                                color: entry.color,
                                margin: "4px 0",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "12px",
                                fontWeight: "500",
                            }}
                        >
                            <span style={{ color: "#4a5568", textTransform: "capitalize" }}>
                                {entry.dataKey}:
                            </span>
                            <span
                                style={{
                                    color: "#2d3748",
                                    fontWeight: "600",
                                }}
                            >
                                ₹{formatNumber(entry.value)}
                            </span>
                        </p>
                    )
                })}
            </div>
        )
    }
    return null
}
